export default __webpack_public_path__ + "assets/images/4945fcd206e8cff60976b288764527e5.svg";